import React from "react";
import MainMenu from "../../components/MainMenu";
import { Grid, Paper } from "@mui/material";
import PlayersList from "../../components/PlayersAreaComponents/PlayersList";

function PlayerArea() {
  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <PlayersList />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
}

export default PlayerArea;
